import React, { createContext, ReactNode, useContext, useEffect, useMemo, useState } from 'react';

export type Language = 'pt' | 'en' | 'es';

const STORAGE_KEY = 'eupartner-language';

const messages = {
  pt: {
    'language.label': 'Idioma',
    'language.portuguese': 'Português',
    'language.english': 'English',
    'language.spanish': 'Español',
    'nav.dashboard': 'Dashboard',
    'nav.profile': 'Os meus dados',
    'nav.clients': 'Clientes',
    'nav.rates': 'Taxas Ativas',
    'nav.transactions': 'Gestão de Transações',
    'nav.partners': 'Parceiros',
    'nav.managers': 'Gestores',
    'nav.settings': 'Definições',
    'nav.notifications': 'Notificações',
    'nav.logout': 'Terminar sessão',
    'logout.title': 'Terminar sessão?',
    'logout.description': 'A sua sessão na Plataforma de Parceiros será terminada e regressará à página de início de sessão.',
    'logout.confirm': 'Terminar sessão',
    'logout.loading': 'A terminar sessão...',
    'logout.expired': 'A sua sessão expirou. Inicie sessão novamente.',
    'logout.error': 'Não foi possível terminar a sessão. Tente novamente.',
    'nav.open': 'Abrir menu',
    'nav.close': 'Fechar menu',
    'auth.platform': 'Plataforma de Parceiros',
    'auth.kicker': 'Gestão simples. Resultados claros.',
    'auth.hero': 'A sua operação financeira, num só lugar.',
    'auth.heroDescription': 'Consulte clientes, taxas, movimentos e saldo numa experiência segura, rápida e construída para o seu dia a dia.',
    'auth.protected': 'Acesso protegido',
    'auth.updated': 'Informação atualizada',
    'landing.navigation': 'Navegação principal',
    'landing.nav.features': 'Vantagens', 'landing.nav.how': 'Como funciona', 'landing.nav.contact': 'Contactos', 'landing.login': 'Entrar',
    'landing.eyebrow': 'Plataforma exclusiva para parceiros Eupago',
    'landing.hero': 'A sua operação.', 'landing.heroAccent': 'Mais simples, todos os dias.',
    'landing.heroDescription': 'Clientes, taxas, transações, saldo e pedidos de levantamento numa plataforma segura, clara e ligada ao ecossistema Eupago.',
    'landing.access': 'Aceder à plataforma', 'landing.discover': 'Conhecer as vantagens',
    'landing.trust.secure': 'Acesso seguro', 'landing.trust.realtime': 'Dados em tempo real', 'landing.trust.support': 'Tecnologia Eupago',
    'landing.preview.label': 'Pré-visualização da plataforma', 'landing.preview.title': 'Visão geral', 'landing.preview.live': 'Em direto',
    'landing.preview.balance': 'Saldo disponível', 'landing.preview.period': 'este mês', 'landing.preview.clients': 'Clientes', 'landing.preview.transactions': 'Transações',
    'landing.preview.status': 'Informação', 'landing.preview.updated': 'Sempre atualizada', 'landing.preview.security': 'Acesso', 'landing.preview.protected': 'Protegido',
    'landing.features.eyebrow': 'Uma área de trabalho completa', 'landing.features.title': 'Tudo o que precisa para gerir a sua atividade.',
    'landing.features.description': 'Ferramentas essenciais organizadas numa experiência consistente, rápida e pensada para parceiros Eupago.',
    'landing.feature1.title': 'Gestão de clientes', 'landing.feature1.description': 'Consulte e mantenha a informação dos seus clientes num único local.',
    'landing.feature2.title': 'Saldo e levantamentos', 'landing.feature2.description': 'Acompanhe o saldo e submeta pedidos de levantamento com clareza.',
    'landing.feature3.title': 'Transações organizadas', 'landing.feature3.description': 'Consulte movimentos, métodos de pagamento e estados atualizados.',
    'landing.feature4.title': 'Acesso protegido', 'landing.feature4.description': 'Autenticação segura e controlo de acesso para os dados da sua operação.',
    'landing.steps.eyebrow': 'Começar é simples', 'landing.steps.title': 'Do acesso à gestão em três passos.',
    'landing.steps.description': 'Uma experiência direta para consultar informação e tomar decisões sem processos complicados.',
    'landing.step1.title': 'Inicie sessão', 'landing.step1.description': 'Utilize as credenciais fornecidas pela equipa Eupago.',
    'landing.step2.title': 'Consulte a operação', 'landing.step2.description': 'Veja clientes, taxas, transações e saldo numa área centralizada.',
    'landing.step3.title': 'Acompanhe em tempo real', 'landing.step3.description': 'Mantenha-se informado e efetue pedidos de forma segura.',
    'landing.cta.eyebrow': 'A sua área de parceiro', 'landing.cta.title': 'Toda a sua operação Eupago está a um clique de distância.', 'landing.cta.button': 'Entrar agora',
    'landing.footer.description': 'Gestão de parceiros com tecnologia Eupago.', 'landing.footer.privacy': 'Privacidade',
    'login.title': 'Bem-vindo de volta',
    'login.description': 'Inicie sessão para gerir a sua conta e acompanhar a operação em tempo real.',
    'login.email': 'Email',
    'login.password': 'Password',
    'login.passwordPlaceholder': 'Introduza a password',
    'login.remember': 'Lembrar-me',
    'login.forgot': 'Esqueceu a palavra-passe?',
    'login.submit': 'Entrar',
    'login.submitting': 'A iniciar sessão...',
    'login.showPassword': 'Mostrar password',
    'login.hidePassword': 'Ocultar password',
    'login.backHome': 'Voltar à página inicial',
    'reset.eyebrow': 'Recuperação de acesso',
    'reset.title': 'Recuperar password',
    'reset.description': 'Indique o email associado à sua conta. Enviaremos as instruções para definir uma nova password.',
    'reset.emailPlaceholder': 'Introduza o seu email',
    'reset.send': 'Enviar instruções',
    'reset.sending': 'A enviar...',
    'reset.back': 'Voltar',
    'newPassword.eyebrow': 'Segurança da conta',
    'newPassword.title': 'Definir nova palavra-passe',
    'newPassword.description': 'Crie uma palavra-passe segura para voltar a aceder à sua área de parceiros.',
    'newPassword.password': 'Nova palavra-passe',
    'newPassword.repeat': 'Repetir nova palavra-passe',
    'newPassword.placeholder': 'Introduza a nova palavra-passe',
    'newPassword.repeatPlaceholder': 'Repita a nova palavra-passe',
    'newPassword.save': 'Guardar nova palavra-passe',
    'newPassword.saving': 'A guardar...',
    'newPassword.requirements': 'Mínimo de 8 caracteres, com maiúscula, minúscula, número e símbolo.',
    'newPassword.strength': 'Força da palavra-passe',
    'newPassword.policyError': 'A palavra-passe deve ter pelo menos 8 caracteres, incluindo maiúscula, minúscula, número e símbolo.',
    'newPassword.mismatch': 'As palavras-passe não coincidem.',
    'newPassword.resetError': 'Não foi possível definir a nova palavra-passe. Confirme os dados e tente novamente.',
    'partners.breadcrumb': 'Lista de Parceiros',
    'partners.title': 'PARCEIROS',
    'partners.description': 'Uma lista de todos os parceiros existentes, incluindo informações como nome, email, website, papel e NIF.',
    'partners.new': 'Novo parceiro',
    'partners.search': 'Pesquisar por nome ou NIF',
    'partners.name': 'Nome',
    'partners.delete.open': 'Eliminar parceiro',
    'partners.delete.warning': 'Ação irreversível',
    'partners.delete.title': 'Eliminar este parceiro?',
    'partners.delete.description': 'O parceiro e o respetivo acesso serão removidos permanentemente. Confirme apenas se pretende continuar.',
    'partners.delete.partner': 'Parceiro selecionado',
    'partners.delete.confirm': 'Eliminar parceiro',
    'partners.delete.deleting': 'A eliminar...',
    'partners.more': 'Ver mais',
    'pagination.showing': 'Exibindo',
    'pagination.to': 'a',
    'pagination.of': 'de',
    'pagination.results': 'resultados',
    'pagination.empty': 'Nenhum resultado encontrado.',
    'pagination.previous': 'Anterior',
    'pagination.next': 'Próximo',
    'dashboard.morning': 'Bom dia',
    'dashboard.afternoon': 'Boa tarde',
    'dashboard.evening': 'Boa noite',
    'dashboard.subtitle': 'O seu backoffice. Controle tudo.',
    'dashboard.included': 'O que está incluído',
    'dashboard.createPartners': 'Criar novos parceiros',
    'dashboard.createRates': 'Criar taxas para parceiros',
    'dashboard.confirmWithdrawals': 'Confirmar pedidos de levantamento de saldo',
    'dashboard.liveTransactions': 'Estado das transações ao minuto',
    'dashboard.partnerCount': 'Número de parceiros registados',
    'dashboard.firstPartner': 'Criar o primeiro parceiro',
    'dashboard.allPartners': 'Todos os parceiros',
    'settings.adminBreadcrumb': 'Definições de Administrador',
    'settings.managerBreadcrumb': 'Definições de Gestor',
    'settings.title': 'Definições de conta',
    'settings.descriptionBefore': 'Aqui encontra a sua',
    'settings.descriptionStrong': 'área de gestão de conta',
    'settings.descriptionAfter': 'onde pode consultar e atualizar as suas informações pessoais e de contacto, garantindo uma experiência personalizada e segura.',
    'settings.accountInfo': 'Informações de conta',
    'settings.accountInfoDescription': 'Detalhes pessoais e alteração de password.',
    'settings.changePassword': 'Alterar password',
    'settings.name': 'Nome',
    'settings.accountType': 'Tipo de conta',
    'settings.createdAt': 'Data de criação',
    'role.admin': 'Administrador',
    'role.manager': 'Gestor',
    'role.partner': 'Parceiro',
    'role.unknown': 'Utilizador desconhecido',
    'admins.breadcrumb': 'Lista de Administradores e Gestores',
    'admins.title': 'ADMINISTRADORES E GESTORES',
    'admins.description': 'Lista de todos os administradores e gestores, com detalhes como nome, email e tipo de conta.',
    'admins.new': 'Novo Admin/Gestor',
    'admins.search': 'Pesquisar por nome ou email',
    'admins.selectRole': 'Selecione o tipo de conta',
    'admins.selectRoleMedium': 'Selecione o tipo...',
    'admins.selectRoleShort': 'Selecione...',
    'admins.all': 'Todos',
    'admins.accountType': 'Tipo de conta',
    'admins.loadError': 'Não foi possível carregar os administradores e gestores.',
    'admins.deleteError': 'Não foi possível eliminar o utilizador.',
    'admins.roleUpdated': 'O tipo de conta foi atualizado com sucesso.',
    'admins.roleUpdateError': 'Não foi possível atualizar o tipo de conta.',
    'admins.create.title': 'Novo administrador ou gestor',
    'admins.create.subtitle': 'Indique o nome e email. O novo utilizador receberá um link para definir a própria palavra-passe.',
    'admins.create.namePlaceholder': 'Introduza o nome completo',
    'admins.create.emailPlaceholder': 'nome@empresa.pt',
    'admins.create.password': 'Palavra-passe',
    'admins.create.passwordPlaceholder': 'Introduza uma palavra-passe segura',
    'admins.create.passwordHint': 'Utilize pelo menos 8 caracteres.',
    'admins.create.nameRequired': 'O nome é obrigatório.',
    'admins.create.emailRequired': 'O email é obrigatório.',
    'admins.create.emailInvalid': 'Introduza um endereço de email válido.',
    'admins.create.emailUsed': 'Este email já está a ser utilizado.',
    'admins.create.passwordRequired': 'A palavra-passe é obrigatória.',
    'admins.create.passwordLength': 'A palavra-passe deve ter pelo menos 8 caracteres.',
    'admins.create.showPassword': 'Mostrar palavra-passe',
    'admins.create.hidePassword': 'Ocultar palavra-passe',
    'admins.create.saving': 'A guardar...',
    'admins.create.success': 'A conta foi criada e foi enviado um link para definir a palavra-passe.',
    'admins.create.passwordSetupInfo': 'A palavra-passe não é definida por si. Enviaremos ao novo utilizador um link seguro para a configurar.',
    'admins.create.error': 'Não foi possível criar a conta. Volte a tentar.',
    'common.delete': 'Eliminar',
    'partnerDashboard.subtitle': 'A sua plataforma. A sua gestão.',
    'partnerDashboard.clients': 'Lista de clientes',
    'partnerDashboard.balance': 'Verificação de saldo atual e acumulado',
    'partnerDashboard.withdrawals': 'Pedidos de levantamento de saldo',
    'partnerDashboard.transactions': 'Estado das transações ao minuto',
    'balance.management': 'Gestão de Transações',
    'balance.account': 'Saldo da Conta',
    'balance.available': 'Saldo disponível',
    'balance.show': 'Mostrar saldo',
    'balance.hide': 'Ocultar saldo',
    'balance.viewTransactions': 'Ver transações',
    'balance.update': 'Atualizar saldo',
    'balance.updating': 'A atualizar...',
    'balance.updated': 'Atualizado!',
    'balance.availableIn': 'Disponível em',
    'balance.nextUpdate': 'Nova atualização disponível em',
    'balance.cooldown': 'A atualização do saldo está disponível a cada 6 horas.',
    'balance.untilNext': 'até novo pedido',
    'balance.withdraw': 'Levantar saldo',
    'transactions.noticeBefore': 'Se pretender cancelar um pedido de levantamento, surgirá um botão apenas no',
    'transactions.pendingState': 'estado pendente',
    'transactions.noticeAfter': 'podendo cancelar ao clicar no ícone que aparecerá na tabela.',
    'transactions.title': 'GESTÃO DE TRANSAÇÕES MONETÁRIAS',
    'transactions.description': 'Todas as suas transações sobre o seu saldo encontram-se aqui.',
    'transactions.orderId': 'ID de pedido',
    'transactions.payment': 'Pagamento',
    'transactions.transactions': 'Transações',
    'transactions.type': 'Tipo',
    'transactions.values': 'Valores',
    'transactions.status': 'Estado',
    'transactions.none': 'Nenhuma transação encontrada.',
    'transactions.client': 'Cliente',
    'transactions.short': 'trans.',
    'transactions.withdrawal': 'Levantamento',
    'transactions.deposit': 'Depósito',
    'transactions.filterType': 'Filtrar transações por tipo',
    'transactions.all': 'Todas',
    'transactions.deposits': 'Depósitos',
    'transactions.withdrawals': 'Levantamentos',
    'transactions.balance': 'Saldo',
    'transactions.cancel': 'Cancelar pedido',
    'common.close': 'Fechar',
    'status.pending': 'Pendente',
    'status.completed': 'Completo',
    'status.canceled': 'Cancelado',
    'status.refunded': 'Reembolsado',
    'rates.breadcrumb': 'Taxas Ativas',
    'rates.title': 'Taxas atualmente ativas',
    'rates.paymentMethod': 'Método de pagamento',
    'rates.description': 'Consulte as taxas atualmente ativas.',
    'rates.none': 'Não existem taxas ativas neste momento.',
    'rates.fixed': 'Taxa fixa',
    'rates.variable': 'Taxa variável',
    'rates.mixed': 'Taxa mista (fixa e variável)',
    'rates.creditCard': 'Cartão de crédito',
    'rates.directDebit': 'Débito direto',
    'profile.breadcrumb': 'Os seus detalhes',
    'profile.title': 'Informações de conta',
    'profile.general': 'Geral',
    'clients.breadcrumb': 'Lista de Clientes',
    'clients.area': 'Área do parceiro',
    'clients.title': 'Clientes',
    'clients.description': 'Consulte dados, pesquise por NIF e exporte a lista. O estado é gerido pela equipa Eupago.',
    'clients.export': 'Exportar CSV',
    'clients.search': 'Pesquisar por nome, CID, NIF ou website',
    'clients.perPage': 'por página',
    'clients.showAll': 'Ver todos',
    'clients.client': 'Cliente',
    'clients.website': 'Website',
    'clients.status': 'Estado',
    'clients.actions': 'Ações',
    'clients.none': 'Nenhum cliente encontrado.',
    'clients.viewDetails': 'Ver detalhes',
    'clients.edit': 'Editar',
    'clients.awaitingApproval': 'Alteração a aguardar aprovação',
    'clients.registeredAt': 'Data de registo',
    'clients.lastWithdrawal': 'Último levantamento',
    'clients.changeStatus': 'Estado da alteração',
    'clients.notes': 'Notas',
    'clients.count': 'cliente(s)',
    'notifications.title': 'Notificações',
    'notifications.partnerDescription': 'Acompanhe as decisões da equipa Eupago sobre os seus pedidos de clientes.',
    'notifications.loading': 'A carregar notificações...',
    'notifications.syncing': 'A sincronizar notificações...',
    'notifications.approvedPlural': 'Aprovadas',
    'notifications.rejectedPlural': 'Rejeitadas',
    'notifications.approved': 'Aprovado',
    'notifications.rejected': 'Rejeitado',
    'notifications.creation': 'Criação',
    'notifications.update': 'Atualização',
    'notifications.reason': 'Motivo',
    'notifications.noDate': 'Data indisponível',
    'notifications.empty': 'Nenhuma notificação nesta categoria',
    'notifications.emptyDescription': 'As decisões futuras aparecerão aqui.',
    'withdrawal.title': 'PEDIDO DE LEVANTAMENTO',
    'withdrawal.minimumNotice': 'Apenas levantamentos a partir de 50,00 € serão aceites.',
    'withdrawal.minimumError': 'O valor mínimo para levantamento é 50,00 €.',
    'withdrawal.request': 'Pedir levantamento',
    'withdrawal.success': 'Pedido de levantamento efetuado com sucesso.',
    'withdrawal.error': 'Não foi possível pedir o levantamento.',
    'withdrawal.retry': 'Volte a tentar.',
    'editClient.title': 'Editar cliente',
    'editClient.description': 'As alterações serão enviadas para aprovação da equipa Eupago. Os dados atuais permanecem ativos até à decisão.',
    'editClient.loading': 'A carregar...',
    'editClient.cidLocked': 'O identificador do cliente não pode ser alterado.',
    'editClient.editableIntroTitle': 'Campos disponíveis para edição',
    'editClient.editableIntro': 'Pode alterar o NIF, o website e as notas. O nome e o CID estão protegidos.',
    'editClient.editable': 'Editável',
    'editClient.locked': 'Bloqueado',
    'editClient.noChanges': 'Não existem alterações para enviar. Modifique pelo menos um campo antes de guardar.',
    'editClient.noChangesTitle': 'Não existem alterações para guardar.',
    'editClient.success': 'Pedido enviado. As alterações aguardam aprovação do administrador.',
    'editClient.save': 'Guardar alterações',
    'editClient.saving': 'A guardar...',
    'common.cancel': 'Cancelar',
    'common.save': 'Guardar',
    'profile.myDetails': 'Os meus dados',
    'profile.partnerData': 'Dados do parceiro',
    'profile.partnerDescription': 'Confirme os dados registados pela equipa Eupago.',
    'profile.address': 'Morada',
    'partnerEdit.list': 'Lista de Parceiros',
    'partnerEdit.edit': 'Editar Parceiro',
    'partnerEdit.registeredAt': 'Registado em',
    'partnerEdit.infoTab': 'Informações do Parceiro',
    'partnerEdit.clientsTab': 'Clientes',
    'partnerEdit.commissionsTab': 'Comissões',
    'partnerEdit.recordsTab': 'Registos',
    'partnerEdit.selectTab': 'Selecionar separador',
    'partnerEdit.area': 'Dados do parceiro',
    'partnerEdit.title': 'Informações e detalhes',
    'partnerEdit.generalSection': 'Informação principal',
    'partnerEdit.contactSection': 'Contactos e localização',
    'partnerEdit.bankSection': 'Dados bancários',
    'partnerEdit.locked': 'Bloqueado',
    'partnerEdit.description': 'Edite contactos, website, IBAN e BIC/SWIFT. O NIF fica bloqueado para manter a identidade fiscal.',
    'partnerEdit.name': 'Nome',
    'partnerEdit.address': 'Morada',
    'partnerEdit.postalCode': 'Código Postal',
    'partnerEdit.notes': 'Notas',
    'partnerEdit.update': 'Atualizar parceiro',
    'partnerEdit.updating': 'A atualizar...',
    'partnerEdit.loadError': 'Não foi possível carregar o parceiro.',
    'partnerEdit.updateError': 'Não foi possível atualizar o parceiro.',
    'partnerEdit.success': 'Parceiro atualizado com sucesso.',
    'clients.loadError': 'Não foi possível carregar os clientes. Tente novamente mais tarde.',
    'partners.loadError': 'Não foi possível carregar os parceiros. Tente novamente mais tarde.',
    'rates.loadError': 'Não foi possível carregar as taxas. Tente novamente mais tarde.',
    'clients.connectionError': 'Não foi possível carregar os clientes. Verifique a ligação e tente novamente.',
    'balance.pendingError': 'Já existe um pedido de levantamento pendente. Cancele-o ou aguarde pela confirmação antes de pedir outro.',
    'balance.updateError': 'Não foi possível atualizar o saldo neste momento.',
    'balance.cancelError': 'Não foi possível cancelar o pedido de levantamento.',
    'balance.syncCompletedTitle': 'Atualização concluída',
    'balance.syncFailedTitle': 'Não foi possível atualizar',
    'balance.updateSuccess': 'O saldo e as transações foram atualizados com sucesso. Poderá repetir a atualização dentro de 6 horas.',
    'balance.noNewTransactions': 'A sincronização terminou, mas não foram encontradas novas transações. Poderá repetir a atualização dentro de 6 horas.',
    'balance.cooldownBlocked': 'O saldo só pode ser atualizado uma vez a cada 6 horas.',
    'notifications.loadError': 'Não foi possível carregar as notificações.',
    'auth.sessionExpired': 'A sessão expirou. Inicie sessão novamente.',
  },
  en: {
    'language.label': 'Language',
    'language.portuguese': 'Português',
    'language.english': 'English',
    'language.spanish': 'Español',
    'nav.dashboard': 'Dashboard',
    'nav.profile': 'My details',
    'nav.clients': 'Clients',
    'nav.rates': 'Active rates',
    'nav.transactions': 'Transaction management',
    'nav.partners': 'Partners',
    'nav.managers': 'Managers',
    'nav.settings': 'Settings',
    'nav.notifications': 'Notifications',
    'nav.logout': 'Sign out',
    'logout.title': 'Sign out?',
    'logout.description': 'Your session on the Partner Platform will end and you will return to the sign-in page.',
    'logout.confirm': 'Sign out',
    'logout.loading': 'Signing out...',
    'logout.expired': 'Your session has expired. Please sign in again.',
    'logout.error': 'Unable to sign out. Please try again.',
    'nav.open': 'Open menu',
    'nav.close': 'Close menu',
    'auth.platform': 'Partner Platform',
    'auth.kicker': 'Simple management. Clear results.',
    'auth.hero': 'Your financial operation, all in one place.',
    'auth.heroDescription': 'Manage clients, rates, transactions and balances through a secure, fast experience built for your daily work.',
    'auth.protected': 'Protected access',
    'auth.updated': 'Up-to-date information',
    'landing.navigation': 'Main navigation',
    'landing.nav.features': 'Benefits', 'landing.nav.how': 'How it works', 'landing.nav.contact': 'Contact', 'landing.login': 'Sign in',
    'landing.eyebrow': 'The exclusive platform for Eupago partners',
    'landing.hero': 'Your operation.', 'landing.heroAccent': 'Simpler, every day.',
    'landing.heroDescription': 'Customers, rates, transactions, balance and withdrawal requests in one secure, clear platform connected to the Eupago ecosystem.',
    'landing.access': 'Access the platform', 'landing.discover': 'Discover the benefits',
    'landing.trust.secure': 'Secure access', 'landing.trust.realtime': 'Real-time data', 'landing.trust.support': 'Eupago technology',
    'landing.preview.label': 'Platform preview', 'landing.preview.title': 'Overview', 'landing.preview.live': 'Live',
    'landing.preview.balance': 'Available balance', 'landing.preview.period': 'this month', 'landing.preview.clients': 'Customers', 'landing.preview.transactions': 'Transactions',
    'landing.preview.status': 'Information', 'landing.preview.updated': 'Always up to date', 'landing.preview.security': 'Access', 'landing.preview.protected': 'Protected',
    'landing.features.eyebrow': 'A complete workspace', 'landing.features.title': 'Everything you need to manage your business.',
    'landing.features.description': 'Essential tools in a consistent, fast experience designed for Eupago partners.',
    'landing.feature1.title': 'Customer management', 'landing.feature1.description': 'View and maintain your customer information in one place.',
    'landing.feature2.title': 'Balance and withdrawals', 'landing.feature2.description': 'Monitor your balance and submit withdrawal requests with clarity.',
    'landing.feature3.title': 'Organised transactions', 'landing.feature3.description': 'View movements, payment methods and up-to-date statuses.',
    'landing.feature4.title': 'Protected access', 'landing.feature4.description': 'Secure authentication and access control for your operation data.',
    'landing.steps.eyebrow': 'Getting started is simple', 'landing.steps.title': 'From sign-in to management in three steps.',
    'landing.steps.description': 'A direct experience for viewing information and making decisions without unnecessary processes.',
    'landing.step1.title': 'Sign in', 'landing.step1.description': 'Use the credentials provided by the Eupago team.',
    'landing.step2.title': 'View your operation', 'landing.step2.description': 'See customers, rates, transactions and balance in one central area.',
    'landing.step3.title': 'Monitor in real time', 'landing.step3.description': 'Stay informed and submit requests securely.',
    'landing.cta.eyebrow': 'Your partner area', 'landing.cta.title': 'Your entire Eupago operation is just one click away.', 'landing.cta.button': 'Sign in now',
    'landing.footer.description': 'Partner management powered by Eupago.', 'landing.footer.privacy': 'Privacy',
    'login.title': 'Welcome back',
    'login.description': 'Sign in to manage your account and monitor your operation in real time.',
    'login.email': 'Email',
    'login.password': 'Password',
    'login.passwordPlaceholder': 'Enter your password',
    'login.remember': 'Remember me',
    'login.forgot': 'Forgot your password?',
    'login.submit': 'Sign in',
    'login.submitting': 'Signing in...',
    'login.showPassword': 'Show password',
    'login.hidePassword': 'Hide password',
    'login.backHome': 'Back to homepage',
    'reset.eyebrow': 'Account recovery',
    'reset.title': 'Reset password',
    'reset.description': 'Enter the email linked to your account. We will send instructions to set a new password.',
    'reset.emailPlaceholder': 'Enter your email',
    'reset.send': 'Send instructions',
    'reset.sending': 'Sending...',
    'reset.back': 'Back',
    'newPassword.eyebrow': 'Account security',
    'newPassword.title': 'Set a new password',
    'newPassword.description': 'Create a secure password to access your partner account again.',
    'newPassword.password': 'New password',
    'newPassword.repeat': 'Repeat new password',
    'newPassword.placeholder': 'Enter the new password',
    'newPassword.repeatPlaceholder': 'Repeat the new password',
    'newPassword.save': 'Save new password',
    'newPassword.saving': 'Saving...',
    'newPassword.requirements': 'Minimum 8 characters, with uppercase, lowercase, number and symbol.',
    'newPassword.strength': 'Password strength',
    'newPassword.policyError': 'The password must contain at least 8 characters, including uppercase, lowercase, number and symbol.',
    'newPassword.mismatch': 'The passwords do not match.',
    'newPassword.resetError': 'Unable to set the new password. Check the information and try again.',
    'partners.breadcrumb': 'Partner list',
    'partners.title': 'PARTNERS',
    'partners.description': 'A list of all existing partners, including information such as name, email, website, role and tax number.',
    'partners.new': 'New partner',
    'partners.search': 'Search by name or tax number',
    'partners.name': 'Name',
    'partners.delete.open': 'Delete partner',
    'partners.delete.warning': 'Irreversible action',
    'partners.delete.title': 'Delete this partner?',
    'partners.delete.description': 'The partner and their access will be permanently removed. Confirm only if you want to continue.',
    'partners.delete.partner': 'Selected partner',
    'partners.delete.confirm': 'Delete partner',
    'partners.delete.deleting': 'Deleting...',
    'partners.more': 'View more',
    'pagination.showing': 'Showing',
    'pagination.to': 'to',
    'pagination.of': 'of',
    'pagination.results': 'results',
    'pagination.empty': 'No results found.',
    'pagination.previous': 'Previous',
    'pagination.next': 'Next',
    'dashboard.morning': 'Good morning',
    'dashboard.afternoon': 'Good afternoon',
    'dashboard.evening': 'Good evening',
    'dashboard.subtitle': 'Your back office. Control everything.',
    'dashboard.included': 'What is included',
    'dashboard.createPartners': 'Create new partners',
    'dashboard.createRates': 'Create rates for partners',
    'dashboard.confirmWithdrawals': 'Confirm balance withdrawal requests',
    'dashboard.liveTransactions': 'Real-time transaction status',
    'dashboard.partnerCount': 'Number of registered partners',
    'dashboard.firstPartner': 'Create the first partner',
    'dashboard.allPartners': 'All partners',
    'settings.adminBreadcrumb': 'Administrator settings',
    'settings.managerBreadcrumb': 'Manager settings',
    'settings.title': 'Account settings',
    'settings.descriptionBefore': 'This is your',
    'settings.descriptionStrong': 'account management area',
    'settings.descriptionAfter': 'where you can view and update your personal and contact information for a personalised and secure experience.',
    'settings.accountInfo': 'Account information',
    'settings.accountInfoDescription': 'Personal details and password management.',
    'settings.changePassword': 'Change password',
    'settings.name': 'Name',
    'settings.accountType': 'Account type',
    'settings.createdAt': 'Creation date',
    'role.admin': 'Administrator',
    'role.manager': 'Manager',
    'role.partner': 'Partner',
    'role.unknown': 'Unknown user',
    'admins.breadcrumb': 'Administrator and manager list',
    'admins.title': 'ADMINISTRATORS AND MANAGERS',
    'admins.description': 'A list of all administrators and managers, including details such as name, email and account type.',
    'admins.new': 'New admin/manager',
    'admins.search': 'Search by name or email',
    'admins.selectRole': 'Select the account type',
    'admins.selectRoleMedium': 'Select the type...',
    'admins.selectRoleShort': 'Select...',
    'admins.all': 'All',
    'admins.accountType': 'Account type',
    'admins.loadError': 'Unable to load administrators and managers.',
    'admins.deleteError': 'Unable to delete the user.',
    'admins.roleUpdated': 'The account type was updated successfully.',
    'admins.roleUpdateError': 'Unable to update the account type.',
    'admins.create.title': 'New administrator or manager',
    'admins.create.subtitle': 'Enter the name and email. The new user will receive a link to set their own password.',
    'admins.create.namePlaceholder': 'Enter the full name',
    'admins.create.emailPlaceholder': 'name@company.com',
    'admins.create.password': 'Password',
    'admins.create.passwordPlaceholder': 'Enter a secure password',
    'admins.create.passwordHint': 'Use at least 8 characters.',
    'admins.create.nameRequired': 'Name is required.',
    'admins.create.emailRequired': 'Email is required.',
    'admins.create.emailInvalid': 'Enter a valid email address.',
    'admins.create.emailUsed': 'This email is already in use.',
    'admins.create.passwordRequired': 'Password is required.',
    'admins.create.passwordLength': 'Password must contain at least 8 characters.',
    'admins.create.showPassword': 'Show password',
    'admins.create.hidePassword': 'Hide password',
    'admins.create.saving': 'Saving...',
    'admins.create.success': 'The account was created and a password setup link was sent.',
    'admins.create.passwordSetupInfo': 'You do not set the password. The new user will receive a secure link to configure it.',
    'admins.create.error': 'Unable to create the account. Please try again.',
    'common.delete': 'Delete',
    'partnerDashboard.subtitle': 'Your platform. Your management.',
    'partnerDashboard.clients': 'Client list',
    'partnerDashboard.balance': 'Current and accumulated balance overview',
    'partnerDashboard.withdrawals': 'Balance withdrawal requests',
    'partnerDashboard.transactions': 'Real-time transaction status',
    'balance.management': 'Transaction management',
    'balance.account': 'Account balance',
    'balance.available': 'Available balance',
    'balance.show': 'Show balance',
    'balance.hide': 'Hide balance',
    'balance.viewTransactions': 'View transactions',
    'balance.update': 'Update balance',
    'balance.updating': 'Updating...',
    'balance.updated': 'Updated!',
    'balance.availableIn': 'Available in',
    'balance.nextUpdate': 'Next update available in',
    'balance.cooldown': 'The balance can be updated every 6 hours.',
    'balance.untilNext': 'until the next request',
    'balance.withdraw': 'Withdraw balance',
    'transactions.noticeBefore': 'To cancel a withdrawal request, a button will only appear when it is in',
    'transactions.pendingState': 'pending status',
    'transactions.noticeAfter': 'You can cancel it using the icon shown in the table.',
    'transactions.title': 'FINANCIAL TRANSACTION MANAGEMENT',
    'transactions.description': 'All transactions affecting your balance are shown here.',
    'transactions.orderId': 'Order ID',
    'transactions.payment': 'Payment',
    'transactions.transactions': 'Transactions',
    'transactions.type': 'Type',
    'transactions.values': 'Amounts',
    'transactions.status': 'Status',
    'transactions.none': 'No transactions found.',
    'transactions.client': 'Client',
    'transactions.short': 'trans.',
    'transactions.withdrawal': 'Withdrawal',
    'transactions.deposit': 'Deposit',
    'transactions.filterType': 'Filter transactions by type',
    'transactions.all': 'All',
    'transactions.deposits': 'Deposits',
    'transactions.withdrawals': 'Withdrawals',
    'transactions.balance': 'Balance',
    'transactions.cancel': 'Cancel request',
    'common.close': 'Close',
    'status.pending': 'Pending',
    'status.completed': 'Completed',
    'status.canceled': 'Canceled',
    'status.refunded': 'Refunded',
    'rates.breadcrumb': 'Active rates',
    'rates.title': 'Currently active rates',
    'rates.paymentMethod': 'Payment method',
    'rates.description': 'Review your currently active rates.',
    'rates.none': 'There are no active rates at the moment.',
    'rates.fixed': 'Fixed rate',
    'rates.variable': 'Variable rate',
    'rates.mixed': 'Mixed rate (fixed and variable)',
    'rates.creditCard': 'Credit card',
    'rates.directDebit': 'Direct debit',
    'profile.breadcrumb': 'Your details',
    'profile.title': 'Account information',
    'profile.general': 'General',
    'clients.breadcrumb': 'Client list',
    'clients.area': 'Partner area',
    'clients.title': 'Clients',
    'clients.description': 'Review client data, search by tax number and export the list. Status is managed by the Eupago team.',
    'clients.export': 'Export CSV',
    'clients.search': 'Search by name, CID, tax number or website',
    'clients.perPage': 'per page',
    'clients.showAll': 'Show all',
    'clients.client': 'Client',
    'clients.website': 'Website',
    'clients.status': 'Status',
    'clients.actions': 'Actions',
    'clients.none': 'No clients found.',
    'clients.viewDetails': 'View details',
    'clients.edit': 'Edit',
    'clients.awaitingApproval': 'Change awaiting approval',
    'clients.registeredAt': 'Registration date',
    'clients.lastWithdrawal': 'Last withdrawal',
    'clients.changeStatus': 'Change status',
    'clients.notes': 'Notes',
    'clients.count': 'client(s)',
    'notifications.title': 'Notifications',
    'notifications.partnerDescription': 'Track the Eupago team’s decisions about your client requests.',
    'notifications.loading': 'Loading notifications...',
    'notifications.syncing': 'Synchronising notifications...',
    'notifications.approvedPlural': 'Approved',
    'notifications.rejectedPlural': 'Rejected',
    'notifications.approved': 'Approved',
    'notifications.rejected': 'Rejected',
    'notifications.creation': 'Creation',
    'notifications.update': 'Update',
    'notifications.reason': 'Reason',
    'notifications.noDate': 'Date unavailable',
    'notifications.empty': 'No notifications in this category',
    'notifications.emptyDescription': 'Future decisions will appear here.',
    'withdrawal.title': 'WITHDRAWAL REQUEST',
    'withdrawal.minimumNotice': 'Only withdrawals of €50.00 or more will be accepted.',
    'withdrawal.minimumError': 'The minimum withdrawal amount is €50.00.',
    'withdrawal.request': 'Request withdrawal',
    'withdrawal.success': 'Withdrawal request submitted successfully.',
    'withdrawal.error': 'Unable to request the withdrawal.',
    'withdrawal.retry': 'Please try again.',
    'editClient.title': 'Edit client',
    'editClient.description': 'Changes will be sent to the Eupago team for approval. Current data remains active until a decision is made.',
    'editClient.loading': 'Loading...',
    'editClient.cidLocked': 'The client identifier cannot be changed.',
    'editClient.editableIntroTitle': 'Fields available for editing',
    'editClient.editableIntro': 'You can change the tax number, website and notes. The name and CID are protected.',
    'editClient.editable': 'Editable',
    'editClient.locked': 'Locked',
    'editClient.noChanges': 'There are no changes to submit. Change at least one field before saving.',
    'editClient.noChangesTitle': 'There are no changes to save.',
    'editClient.success': 'Request submitted. The changes are awaiting administrator approval.',
    'editClient.save': 'Save changes',
    'editClient.saving': 'Saving...',
    'common.cancel': 'Cancel',
    'common.save': 'Save',
    'profile.myDetails': 'My details',
    'profile.partnerData': 'Partner details',
    'profile.partnerDescription': 'Review the details registered by the Eupago team.',
    'profile.address': 'Address',
    'partnerEdit.list': 'Partner list',
    'partnerEdit.edit': 'Edit partner',
    'partnerEdit.registeredAt': 'Registered on',
    'partnerEdit.infoTab': 'Partner information',
    'partnerEdit.clientsTab': 'Clients',
    'partnerEdit.commissionsTab': 'Commissions',
    'partnerEdit.recordsTab': 'Records',
    'partnerEdit.selectTab': 'Select a tab',
    'partnerEdit.area': 'Partner details',
    'partnerEdit.title': 'Information and details',
    'partnerEdit.generalSection': 'General information',
    'partnerEdit.contactSection': 'Contact and location',
    'partnerEdit.bankSection': 'Bank details',
    'partnerEdit.locked': 'Locked',
    'partnerEdit.description': 'Edit contacts, website, IBAN and BIC/SWIFT. The tax number is locked to preserve the fiscal identity.',
    'partnerEdit.name': 'Name',
    'partnerEdit.address': 'Address',
    'partnerEdit.postalCode': 'Postal code',
    'partnerEdit.notes': 'Notes',
    'partnerEdit.update': 'Update partner',
    'partnerEdit.updating': 'Updating...',
    'partnerEdit.loadError': 'Unable to load the partner.',
    'partnerEdit.updateError': 'Unable to update the partner.',
    'partnerEdit.success': 'Partner updated successfully.',
    'clients.loadError': 'Unable to load clients. Please try again later.',
    'partners.loadError': 'Unable to load partners. Please try again later.',
    'rates.loadError': 'Unable to load rates. Please try again later.',
    'clients.connectionError': 'Unable to load clients. Check your connection and try again.',
    'balance.pendingError': 'A withdrawal request is already pending. Cancel it or wait for confirmation before requesting another.',
    'balance.updateError': 'Unable to update the balance at this time.',
    'balance.cancelError': 'Unable to cancel the withdrawal request.',
    'balance.syncCompletedTitle': 'Update completed',
    'balance.syncFailedTitle': 'Unable to update',
    'balance.updateSuccess': 'The balance and transactions were updated successfully. You can update them again in 6 hours.',
    'balance.noNewTransactions': 'Synchronization finished, but no new transactions were found. You can update again in 6 hours.',
    'balance.cooldownBlocked': 'The balance can only be updated once every 6 hours.',
    'notifications.loadError': 'Unable to load notifications.',
    'auth.sessionExpired': 'Your session has expired. Please sign in again.',
  },
  es: {
    'language.label': 'Idioma',
    'language.portuguese': 'Português',
    'language.english': 'English',
    'language.spanish': 'Español',
    'nav.dashboard': 'Panel',
    'nav.profile': 'Mis datos',
    'nav.clients': 'Clientes',
    'nav.rates': 'Tarifas activas',
    'nav.transactions': 'Gestión de transacciones',
    'nav.partners': 'Socios',
    'nav.managers': 'Gestores',
    'nav.settings': 'Configuración',
    'nav.notifications': 'Notificaciones',
    'nav.logout': 'Cerrar sesión',
    'logout.title': '¿Cerrar sesión?',
    'logout.description': 'Tu sesión en la Plataforma de Socios finalizará y volverás a la página de inicio de sesión.',
    'logout.confirm': 'Cerrar sesión',
    'logout.loading': 'Cerrando sesión...',
    'logout.expired': 'Tu sesión ha caducado. Vuelve a iniciar sesión.',
    'logout.error': 'No se pudo cerrar la sesión. Inténtalo de nuevo.',
    'nav.open': 'Abrir menú',
    'nav.close': 'Cerrar menú',
    'auth.platform': 'Plataforma de Socios',
    'auth.kicker': 'Gestión sencilla. Resultados claros.',
    'auth.hero': 'Tu operación financiera, en un solo lugar.',
    'auth.heroDescription': 'Gestiona clientes, tarifas, movimientos y saldo con una experiencia segura, rápida y creada para tu día a día.',
    'auth.protected': 'Acceso protegido',
    'auth.updated': 'Información actualizada',
    'landing.navigation': 'Navegación principal',
    'landing.nav.features': 'Ventajas', 'landing.nav.how': 'Cómo funciona', 'landing.nav.contact': 'Contacto', 'landing.login': 'Iniciar sesión',
    'landing.eyebrow': 'La plataforma exclusiva para socios de Eupago',
    'landing.hero': 'Tu operación.', 'landing.heroAccent': 'Más sencilla, cada día.',
    'landing.heroDescription': 'Clientes, tarifas, transacciones, saldo y solicitudes de retirada en una plataforma segura, clara y conectada al ecosistema Eupago.',
    'landing.access': 'Acceder a la plataforma', 'landing.discover': 'Descubrir las ventajas',
    'landing.trust.secure': 'Acceso seguro', 'landing.trust.realtime': 'Datos en tiempo real', 'landing.trust.support': 'Tecnología Eupago',
    'landing.preview.label': 'Vista previa de la plataforma', 'landing.preview.title': 'Resumen', 'landing.preview.live': 'En directo',
    'landing.preview.balance': 'Saldo disponible', 'landing.preview.period': 'este mes', 'landing.preview.clients': 'Clientes', 'landing.preview.transactions': 'Transacciones',
    'landing.preview.status': 'Información', 'landing.preview.updated': 'Siempre actualizada', 'landing.preview.security': 'Acceso', 'landing.preview.protected': 'Protegido',
    'landing.features.eyebrow': 'Un espacio de trabajo completo', 'landing.features.title': 'Todo lo que necesitas para gestionar tu actividad.',
    'landing.features.description': 'Herramientas esenciales organizadas en una experiencia coherente, rápida y pensada para socios de Eupago.',
    'landing.feature1.title': 'Gestión de clientes', 'landing.feature1.description': 'Consulta y mantén la información de tus clientes en un único lugar.',
    'landing.feature2.title': 'Saldo y retiradas', 'landing.feature2.description': 'Controla el saldo y envía solicitudes de retirada con claridad.',
    'landing.feature3.title': 'Transacciones organizadas', 'landing.feature3.description': 'Consulta movimientos, métodos de pago y estados actualizados.',
    'landing.feature4.title': 'Acceso protegido', 'landing.feature4.description': 'Autenticación segura y control de acceso para los datos de tu operación.',
    'landing.steps.eyebrow': 'Empezar es sencillo', 'landing.steps.title': 'Del acceso a la gestión en tres pasos.',
    'landing.steps.description': 'Una experiencia directa para consultar información y tomar decisiones sin procesos complicados.',
    'landing.step1.title': 'Inicia sesión', 'landing.step1.description': 'Utiliza las credenciales proporcionadas por el equipo Eupago.',
    'landing.step2.title': 'Consulta tu operación', 'landing.step2.description': 'Visualiza clientes, tarifas, transacciones y saldo en un área centralizada.',
    'landing.step3.title': 'Supervisa en tiempo real', 'landing.step3.description': 'Mantente informado y envía solicitudes de forma segura.',
    'landing.cta.eyebrow': 'Tu área de socio', 'landing.cta.title': 'Toda tu operación Eupago está a un clic de distancia.', 'landing.cta.button': 'Entrar ahora',
    'landing.footer.description': 'Gestión de socios con tecnología Eupago.', 'landing.footer.privacy': 'Privacidad',
    'login.title': 'Bienvenido de nuevo',
    'login.description': 'Inicia sesión para gestionar tu cuenta y supervisar la operación en tiempo real.',
    'login.email': 'Email',
    'login.password': 'Contraseña',
    'login.passwordPlaceholder': 'Introduce tu contraseña',
    'login.remember': 'Recordarme',
    'login.forgot': '¿Has olvidado tu contraseña?',
    'login.submit': 'Iniciar sesión',
    'login.submitting': 'Iniciando sesión...',
    'login.showPassword': 'Mostrar contraseña',
    'login.hidePassword': 'Ocultar contraseña',
    'login.backHome': 'Volver a la página de inicio',
    'reset.eyebrow': 'Recuperación de acceso',
    'reset.title': 'Recuperar contraseña',
    'reset.description': 'Introduce el email asociado a tu cuenta. Enviaremos instrucciones para definir una nueva contraseña.',
    'reset.emailPlaceholder': 'Introduce tu email',
    'reset.send': 'Enviar instrucciones',
    'reset.sending': 'Enviando...',
    'reset.back': 'Volver',
    'newPassword.eyebrow': 'Seguridad de la cuenta',
    'newPassword.title': 'Definir una nueva contraseña',
    'newPassword.description': 'Crea una contraseña segura para volver a acceder a tu área de socios.',
    'newPassword.password': 'Nueva contraseña',
    'newPassword.repeat': 'Repetir nueva contraseña',
    'newPassword.placeholder': 'Introduce la nueva contraseña',
    'newPassword.repeatPlaceholder': 'Repite la nueva contraseña',
    'newPassword.save': 'Guardar nueva contraseña',
    'newPassword.saving': 'Guardando...',
    'newPassword.requirements': 'Mínimo de 8 caracteres, con mayúscula, minúscula, número y símbolo.',
    'newPassword.strength': 'Seguridad de la contraseña',
    'newPassword.policyError': 'La contraseña debe tener al menos 8 caracteres, incluyendo mayúscula, minúscula, número y símbolo.',
    'newPassword.mismatch': 'Las contraseñas no coinciden.',
    'newPassword.resetError': 'No se pudo definir la nueva contraseña. Comprueba los datos e inténtalo de nuevo.',
    'partners.breadcrumb': 'Lista de socios',
    'partners.title': 'SOCIOS',
    'partners.description': 'Una lista de todos los socios existentes, con información como nombre, email, sitio web, función y NIF.',
    'partners.new': 'Nuevo socio',
    'partners.search': 'Buscar por nombre o NIF',
    'partners.name': 'Nombre',
    'partners.delete.open': 'Eliminar socio',
    'partners.delete.warning': 'Acción irreversible',
    'partners.delete.title': '¿Eliminar este socio?',
    'partners.delete.description': 'El socio y su acceso se eliminarán permanentemente. Confirma únicamente si deseas continuar.',
    'partners.delete.partner': 'Socio seleccionado',
    'partners.delete.confirm': 'Eliminar socio',
    'partners.delete.deleting': 'Eliminando...',
    'partners.more': 'Ver más',
    'pagination.showing': 'Mostrando',
    'pagination.to': 'a',
    'pagination.of': 'de',
    'pagination.results': 'resultados',
    'pagination.empty': 'No se encontraron resultados.',
    'pagination.previous': 'Anterior',
    'pagination.next': 'Siguiente',
    'dashboard.morning': 'Buenos días',
    'dashboard.afternoon': 'Buenas tardes',
    'dashboard.evening': 'Buenas noches',
    'dashboard.subtitle': 'Tu backoffice. Controla todo.',
    'dashboard.included': 'Qué está incluido',
    'dashboard.createPartners': 'Crear nuevos socios',
    'dashboard.createRates': 'Crear tarifas para socios',
    'dashboard.confirmWithdrawals': 'Confirmar solicitudes de retirada de saldo',
    'dashboard.liveTransactions': 'Estado de las transacciones en tiempo real',
    'dashboard.partnerCount': 'Número de socios registrados',
    'dashboard.firstPartner': 'Crear el primer socio',
    'dashboard.allPartners': 'Todos los socios',
    'settings.adminBreadcrumb': 'Configuración del administrador',
    'settings.managerBreadcrumb': 'Configuración del gestor',
    'settings.title': 'Configuración de la cuenta',
    'settings.descriptionBefore': 'Esta es tu',
    'settings.descriptionStrong': 'área de gestión de cuenta',
    'settings.descriptionAfter': 'donde puedes consultar y actualizar tus datos personales y de contacto para disfrutar de una experiencia personalizada y segura.',
    'settings.accountInfo': 'Información de la cuenta',
    'settings.accountInfoDescription': 'Datos personales y cambio de contraseña.',
    'settings.changePassword': 'Cambiar contraseña',
    'settings.name': 'Nombre',
    'settings.accountType': 'Tipo de cuenta',
    'settings.createdAt': 'Fecha de creación',
    'role.admin': 'Administrador',
    'role.manager': 'Gestor',
    'role.partner': 'Socio',
    'role.unknown': 'Usuario desconocido',
    'admins.breadcrumb': 'Lista de administradores y gestores',
    'admins.title': 'ADMINISTRADORES Y GESTORES',
    'admins.description': 'Lista de todos los administradores y gestores, con detalles como nombre, email y tipo de cuenta.',
    'admins.new': 'Nuevo administrador/gestor',
    'admins.search': 'Buscar por nombre o email',
    'admins.selectRole': 'Selecciona el tipo de cuenta',
    'admins.selectRoleMedium': 'Selecciona el tipo...',
    'admins.selectRoleShort': 'Selecciona...',
    'admins.all': 'Todos',
    'admins.accountType': 'Tipo de cuenta',
    'admins.loadError': 'No se pudieron cargar los administradores y gestores.',
    'admins.deleteError': 'No se pudo eliminar el usuario.',
    'admins.roleUpdated': 'El tipo de cuenta se actualizó correctamente.',
    'admins.roleUpdateError': 'No se pudo actualizar el tipo de cuenta.',
    'admins.create.title': 'Nuevo administrador o gestor',
    'admins.create.subtitle': 'Indica el nombre y el email. El nuevo usuario recibirá un enlace para definir su propia contraseña.',
    'admins.create.namePlaceholder': 'Introduce el nombre completo',
    'admins.create.emailPlaceholder': 'nombre@empresa.es',
    'admins.create.password': 'Contraseña',
    'admins.create.passwordPlaceholder': 'Introduce una contraseña segura',
    'admins.create.passwordHint': 'Utiliza al menos 8 caracteres.',
    'admins.create.nameRequired': 'El nombre es obligatorio.',
    'admins.create.emailRequired': 'El email es obligatorio.',
    'admins.create.emailInvalid': 'Introduce una dirección de email válida.',
    'admins.create.emailUsed': 'Este email ya está en uso.',
    'admins.create.passwordRequired': 'La contraseña es obligatoria.',
    'admins.create.passwordLength': 'La contraseña debe tener al menos 8 caracteres.',
    'admins.create.showPassword': 'Mostrar contraseña',
    'admins.create.hidePassword': 'Ocultar contraseña',
    'admins.create.saving': 'Guardando...',
    'admins.create.success': 'La cuenta se ha creado y se ha enviado un enlace para definir la contraseña.',
    'admins.create.passwordSetupInfo': 'La contraseña no la defines tú. El nuevo usuario recibirá un enlace seguro para configurarla.',
    'admins.create.error': 'No se pudo crear la cuenta. Inténtalo de nuevo.',
    'common.delete': 'Eliminar',
    'partnerDashboard.subtitle': 'Tu plataforma. Tu gestión.',
    'partnerDashboard.clients': 'Lista de clientes',
    'partnerDashboard.balance': 'Consulta del saldo actual y acumulado',
    'partnerDashboard.withdrawals': 'Solicitudes de retirada de saldo',
    'partnerDashboard.transactions': 'Estado de las transacciones en tiempo real',
    'balance.management': 'Gestión de transacciones',
    'balance.account': 'Saldo de la cuenta',
    'balance.available': 'Saldo disponible',
    'balance.show': 'Mostrar saldo',
    'balance.hide': 'Ocultar saldo',
    'balance.viewTransactions': 'Ver transacciones',
    'balance.update': 'Actualizar saldo',
    'balance.updating': 'Actualizando...',
    'balance.updated': '¡Actualizado!',
    'balance.availableIn': 'Disponible en',
    'balance.nextUpdate': 'Próxima actualización disponible en',
    'balance.cooldown': 'El saldo se puede actualizar cada 6 horas.',
    'balance.untilNext': 'hasta la próxima solicitud',
    'balance.withdraw': 'Retirar saldo',
    'transactions.noticeBefore': 'Para cancelar una solicitud de retirada, el botón solo aparecerá cuando esté en',
    'transactions.pendingState': 'estado pendiente',
    'transactions.noticeAfter': 'Puedes cancelarla mediante el icono que aparecerá en la tabla.',
    'transactions.title': 'GESTIÓN DE TRANSACCIONES MONETARIAS',
    'transactions.description': 'Aquí se muestran todas las transacciones relacionadas con tu saldo.',
    'transactions.orderId': 'ID del pedido',
    'transactions.payment': 'Pago',
    'transactions.transactions': 'Transacciones',
    'transactions.type': 'Tipo',
    'transactions.values': 'Importes',
    'transactions.status': 'Estado',
    'transactions.none': 'No se encontraron transacciones.',
    'transactions.client': 'Cliente',
    'transactions.short': 'trans.',
    'transactions.withdrawal': 'Retirada',
    'transactions.deposit': 'Depósito',
    'transactions.filterType': 'Filtrar transacciones por tipo',
    'transactions.all': 'Todas',
    'transactions.deposits': 'Depósitos',
    'transactions.withdrawals': 'Retiradas',
    'transactions.balance': 'Saldo',
    'transactions.cancel': 'Cancelar solicitud',
    'common.close': 'Cerrar',
    'status.pending': 'Pendiente',
    'status.completed': 'Completado',
    'status.canceled': 'Cancelado',
    'status.refunded': 'Reembolsado',
    'rates.breadcrumb': 'Tarifas activas',
    'rates.title': 'Tarifas actualmente activas',
    'rates.paymentMethod': 'Método de pago',
    'rates.description': 'Consulta tus tarifas actualmente activas.',
    'rates.none': 'No hay tarifas activas en este momento.',
    'rates.fixed': 'Tarifa fija',
    'rates.variable': 'Tarifa variable',
    'rates.mixed': 'Tarifa mixta (fija y variable)',
    'rates.creditCard': 'Tarjeta de crédito',
    'rates.directDebit': 'Débito directo',
    'profile.breadcrumb': 'Tus datos',
    'profile.title': 'Información de la cuenta',
    'profile.general': 'General',
    'clients.breadcrumb': 'Lista de clientes',
    'clients.area': 'Área del socio',
    'clients.title': 'Clientes',
    'clients.description': 'Consulta los datos, busca por NIF y exporta la lista. El estado lo gestiona el equipo de Eupago.',
    'clients.export': 'Exportar CSV',
    'clients.search': 'Buscar por nombre, CID, NIF o sitio web',
    'clients.perPage': 'por página',
    'clients.showAll': 'Ver todos',
    'clients.client': 'Cliente',
    'clients.website': 'Sitio web',
    'clients.status': 'Estado',
    'clients.actions': 'Acciones',
    'clients.none': 'No se encontraron clientes.',
    'clients.viewDetails': 'Ver detalles',
    'clients.edit': 'Editar',
    'clients.awaitingApproval': 'Cambio pendiente de aprobación',
    'clients.registeredAt': 'Fecha de registro',
    'clients.lastWithdrawal': 'Última retirada',
    'clients.changeStatus': 'Estado del cambio',
    'clients.notes': 'Notas',
    'clients.count': 'cliente(s)',
    'notifications.title': 'Notificaciones',
    'notifications.partnerDescription': 'Consulta las decisiones del equipo de Eupago sobre tus solicitudes de clientes.',
    'notifications.loading': 'Cargando notificaciones...',
    'notifications.syncing': 'Sincronizando notificaciones...',
    'notifications.approvedPlural': 'Aprobadas',
    'notifications.rejectedPlural': 'Rechazadas',
    'notifications.approved': 'Aprobado',
    'notifications.rejected': 'Rechazado',
    'notifications.creation': 'Creación',
    'notifications.update': 'Actualización',
    'notifications.reason': 'Motivo',
    'notifications.noDate': 'Fecha no disponible',
    'notifications.empty': 'No hay notificaciones en esta categoría',
    'notifications.emptyDescription': 'Las próximas decisiones aparecerán aquí.',
    'withdrawal.title': 'SOLICITUD DE RETIRADA',
    'withdrawal.minimumNotice': 'Solo se aceptarán retiradas de 50,00 € o más.',
    'withdrawal.minimumError': 'El importe mínimo de retirada es de 50,00 €.',
    'withdrawal.request': 'Solicitar retirada',
    'withdrawal.success': 'Solicitud de retirada enviada correctamente.',
    'withdrawal.error': 'No se pudo solicitar la retirada.',
    'withdrawal.retry': 'Inténtalo de nuevo.',
    'editClient.title': 'Editar cliente',
    'editClient.description': 'Los cambios se enviarán al equipo de Eupago para su aprobación. Los datos actuales permanecerán activos hasta que se tome una decisión.',
    'editClient.loading': 'Cargando...',
    'editClient.cidLocked': 'El identificador del cliente no se puede modificar.',
    'editClient.editableIntroTitle': 'Campos disponibles para editar',
    'editClient.editableIntro': 'Puedes cambiar el NIF, el sitio web y las notas. El nombre y el CID están protegidos.',
    'editClient.editable': 'Editable',
    'editClient.locked': 'Bloqueado',
    'editClient.noChanges': 'No hay cambios para enviar. Modifica al menos un campo antes de guardar.',
    'editClient.noChangesTitle': 'No hay cambios para guardar.',
    'editClient.success': 'Solicitud enviada. Los cambios están pendientes de aprobación por parte del administrador.',
    'editClient.save': 'Guardar cambios',
    'editClient.saving': 'Guardando...',
    'common.cancel': 'Cancelar',
    'common.save': 'Guardar',
    'profile.myDetails': 'Mis datos',
    'profile.partnerData': 'Datos del socio',
    'profile.partnerDescription': 'Comprueba los datos registrados por el equipo de Eupago.',
    'profile.address': 'Dirección',
    'partnerEdit.list': 'Lista de socios',
    'partnerEdit.edit': 'Editar socio',
    'partnerEdit.registeredAt': 'Registrado el',
    'partnerEdit.infoTab': 'Información del socio',
    'partnerEdit.clientsTab': 'Clientes',
    'partnerEdit.commissionsTab': 'Comisiones',
    'partnerEdit.recordsTab': 'Registros',
    'partnerEdit.selectTab': 'Seleccionar una pestaña',
    'partnerEdit.area': 'Datos del socio',
    'partnerEdit.title': 'Información y detalles',
    'partnerEdit.generalSection': 'Información general',
    'partnerEdit.contactSection': 'Contacto y ubicación',
    'partnerEdit.bankSection': 'Datos bancarios',
    'partnerEdit.locked': 'Bloqueado',
    'partnerEdit.description': 'Edita los contactos, el sitio web, el IBAN y el BIC/SWIFT. El NIF está bloqueado para preservar la identidad fiscal.',
    'partnerEdit.name': 'Nombre',
    'partnerEdit.address': 'Dirección',
    'partnerEdit.postalCode': 'Código postal',
    'partnerEdit.notes': 'Notas',
    'partnerEdit.update': 'Actualizar socio',
    'partnerEdit.updating': 'Actualizando...',
    'partnerEdit.loadError': 'No se pudo cargar el socio.',
    'partnerEdit.updateError': 'No se pudo actualizar el socio.',
    'partnerEdit.success': 'Socio actualizado correctamente.',
    'clients.loadError': 'No se pudieron cargar los clientes. Inténtalo de nuevo más tarde.',
    'partners.loadError': 'No se pudieron cargar los socios. Inténtalo de nuevo más tarde.',
    'rates.loadError': 'No se pudieron cargar las tarifas. Inténtalo de nuevo más tarde.',
    'clients.connectionError': 'No se pudieron cargar los clientes. Comprueba la conexión e inténtalo de nuevo.',
    'balance.pendingError': 'Ya hay una solicitud de retirada pendiente. Cancélala o espera a la confirmación antes de solicitar otra.',
    'balance.updateError': 'No se pudo actualizar el saldo en este momento.',
    'balance.cancelError': 'No se pudo cancelar la solicitud de retirada.',
    'balance.syncCompletedTitle': 'Actualización completada',
    'balance.syncFailedTitle': 'No se pudo actualizar',
    'balance.updateSuccess': 'El saldo y las transacciones se actualizaron correctamente. Podrá actualizarlos de nuevo dentro de 6 horas.',
    'balance.noNewTransactions': 'La sincronización terminó, pero no se encontraron nuevas transacciones. Podrá actualizar de nuevo dentro de 6 horas.',
    'balance.cooldownBlocked': 'El saldo solo se puede actualizar una vez cada 6 horas.',
    'notifications.loadError': 'No se pudieron cargar las notificaciones.',
    'auth.sessionExpired': 'La sesión ha caducado. Vuelve a iniciar sesión.',
  },
} as const;

type MessageKey = keyof typeof messages.pt;

type LanguageContextValue = {
  language: Language;
  setLanguage: (language: Language) => void;
  t: (key: MessageKey) => string;
};

const LanguageContext = createContext<LanguageContextValue | null>(null);

const getInitialLanguage = (): Language => {
  const saved = localStorage.getItem(STORAGE_KEY);
  if (saved === 'pt' || saved === 'en' || saved === 'es') return saved;

  const browserLanguage = navigator.language.toLowerCase();
  if (browserLanguage.startsWith('es')) return 'es';
  if (browserLanguage.startsWith('en')) return 'en';
  return 'pt';
};

export function LanguageProvider({ children }: { children: ReactNode }) {
  const [language, setLanguage] = useState<Language>(getInitialLanguage);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, language);
    document.documentElement.lang = language === 'pt' ? 'pt-PT' : language;
  }, [language]);

  const value = useMemo<LanguageContextValue>(() => ({
    language,
    setLanguage,
    t: (key) => messages[language][key] || messages.pt[key],
  }), [language]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useTranslation() {
  const context = useContext(LanguageContext);
  if (!context) throw new Error('useTranslation must be used within LanguageProvider');
  return context;
}
